import { circularProgressClasses } from '@mui/material';
import type { Components, Theme } from '@mui/material/styles';

import palette from '@/theme/palette';

declare module '@mui/material/CircularProgress' {
  interface CircularProgressProps {
    type?: 'process' | 'process-buffer';
  }
}

const MuiCircularProgress: Components<Theme>['MuiCircularProgress'] = {
  variants: [
    {
      props: ({ type, variant }) => type === 'process' && variant === 'determinate',
      style: {
        [`& .${circularProgressClasses.circle}`]: {
          stroke: palette.primary[600]
        }
      }
    },
    {
      props: ({ type, variant }) => type === 'process-buffer' && variant === 'determinate',
      style: {
        [`& .${circularProgressClasses.circle}`]: {
          stroke: palette.primary[100]
        }
      }
    }
  ]
};

export default MuiCircularProgress;
